/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { getLocale, useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Button, ErrorBrowserHeader, MeetingId, Modal, YunxinBottom, message } from '@/components';
import MeetingModel from '@/models/meeting';
import Style from './index.less';
import DevicePanel from '../DevicePanel';
import PrivatePolicy, { openPrivatePolicy } from '../PrivatePolicy';
import classNames from 'classnames';
import FirstEnter from '../FirstEnter';
import LoginHeader from '../LoginHeader';
import { elkLog } from '@/utils/elkReport';
import { getMeetingTime } from '@/utils/common';
import { Input } from 'antd';

interface LoginInputProps {
  meetingId: string;
  isMICChecking: boolean;
  mustCheck: boolean;
  checkMIC: any;
  meeting?: MeetingModel;
  onMicSwitchChange: any;
  btnLoading: boolean;
  setFirstMemberNotifyOn: any;
  joinMeeting: any;
  onInputChange: any;
}

const LoginInput: React.FC<LoginInputProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const {
      isMICChecking,
      mustCheck,
      checkMIC,
      onMicSwitchChange,
      meetingId,
      meeting,
      btnLoading,
      setFirstMemberNotifyOn,
      joinMeeting,
      onInputChange,
    } = props;
    const { formatMessage } = useIntl();
    const inputRef = React.useRef<HTMLInputElement>(null);
    const [password, setPassword] = useState('');
    const [passwordUI, setPasswordUI] = useState('');

    const [hasError, setHasError] = useState<boolean>(false);
    const [pwdError, setPwdError] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState('');
    const [agreePolicy, setAgreePolicy] = useState(false);

    const checkPrivate = React.useCallback(
      async (callback: (name: string, password: string) => void, agree: boolean) => {
        const linkStyle: React.CSSProperties = {
          cursor: 'pointer',
          color: '#1f86ff',
          marginLeft: getLocale() === 'zh-CN' ? '0.5em' : 0,
          marginRight: getLocale() === 'ja' ? '0.5em' : 0,
        };
        // 先判断是否有入会人员 如果没有提示错误

        if (!inputValue || (meeting?.info?.needPassword && (!password || password.length !== 6))) {
          !inputValue && setHasError(true);
          meeting?.info?.needPassword && !password && setPwdError(true);
          return;
        }

        if (agree) {
          callback(inputValue, password);
        } else {
          Modal.confirm({
            title: formatMessage({ id: 'PROMPT' }).replace(/^[a-z]/, (value) =>
              value.toLocaleUpperCase()
            ),
            okText: formatMessage({ id: 'AGREE' }),
            cancelText: formatMessage({ id: 'CANCEL' }),
            okButtonProps: {
              danger: false,
            },
            content:
              getLocale() === 'ja' ? (
                <div>
                  <span style={linkStyle} onClick={openPrivatePolicy}>
                    {formatMessage({ id: 'PRIVACY_POLICY' })}
                  </span>
                  <span>{formatMessage({ id: 'PLEASE_AGREE_TO' })}</span>
                </div>
              ) : (
                <div>
                  <span>{formatMessage({ id: 'PLEASE_AGREE_TO' })}</span>
                  <span style={linkStyle} onClick={openPrivatePolicy}>
                    {formatMessage({ id: 'PRIVACY_POLICY' })}
                  </span>
                </div>
              ),
            onOk: () => {
              setAgreePolicy(true);
              callback(inputValue, password);
            },
          });
        }
      },
      [inputValue, password, meeting?.info?.needPassword]
    );

    const nextStep = () => {
      const linkStyle: React.CSSProperties = {
        cursor: 'pointer',
        color: '#1f86ff',
        marginLeft: getLocale() === 'zh-CN' ? '0.5em' : 0,
        marginRight: getLocale() === 'ja' ? '0.5em' : 0,
      };
      // 先判断是否有入会人员 如果没有提示错误
      if (!inputValue) {
        setHasError(true);
        return;
      }

      if (agreePolicy) {
        checkMIC();
      } else {
        Modal.confirm({
          title: formatMessage({ id: 'PROMPT' }).replace(/^[a-z]/, (value) =>
            value.toLocaleUpperCase()
          ),
          okText: formatMessage({ id: 'AGREE' }),
          cancelText: formatMessage({ id: 'CANCEL' }),
          okButtonProps: {
            danger: false,
          },
          content:
            getLocale() === 'ja' ? (
              <div>
                <span style={linkStyle} onClick={openPrivatePolicy}>
                  {formatMessage({ id: 'PRIVACY_POLICY' })}
                </span>
                <span>{formatMessage({ id: 'PLEASE_AGREE_TO' })}</span>
              </div>
            ) : (
              <div>
                <span>{formatMessage({ id: 'PLEASE_AGREE_TO' })}</span>
                <span style={linkStyle} onClick={openPrivatePolicy}>
                  {formatMessage({ id: 'PRIVACY_POLICY' })}
                </span>
              </div>
            ),
          onOk: () => {
            setAgreePolicy(true);
            checkMIC();
          },
        });
      }
    };
    const onInputNameChange = React.useCallback((e: any) => {
      // eslint-disable-next-line no-misleading-character-class
      const emojiReg =
        /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      let { value } = e.target;
      if (emojiReg.test(value)) {
        value = value.replace(emojiReg, '');
      }
      setInputValue(value);
      onInputChange(value);
      if (value) {
        setHasError(false);
      }
    }, []);

    const onPasswordChange = React.useCallback(
      (e: any) => {
        const inputString = e.target.value.replace(/\s/g, '');
        if (/^[0-9]+$/.test(inputString) || !inputString) {
          setPassword(inputString.slice(0, 6));
          setPwdError(false);
          if (e.target.value.length <= 3) {
            setPasswordUI(e.target.value);
          } else if (
            e.target.value.length > 3 &&
            e.target.value !== '' &&
            e.target.value.length >= passwordUI.length
          ) {
            setPasswordUI(inputString.slice(0, 3) + ' ' + inputString.slice(3, 6));
          } else if (e.target.value.length > 4) {
            setPasswordUI(e.target.value);
          } else {
            setPasswordUI(inputString);
          }
        }
      },
      [passwordUI]
    );

    React.useEffect(() => {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 200);
    }, []);

    return (
      <div className={Style['popo-meeting-ready']} style={isMICChecking ? { display: 'none' } : {}}>
        <ErrorBrowserHeader show />
        <LoginHeader></LoginHeader>
        <div className={Style.content}>
          <YunxinBottom />
          <div className={Style.left}>
            <div className={Style['left-content']}>
              <DevicePanel
                mustCheck={mustCheck}
                checkMIC={checkMIC}
                onMicSwitchChange={onMicSwitchChange}
              />
            </div>
          </div>
          <div className={Style.right}>
            <div className={Style['right-content']}>
              <div className={Style.title}>{meeting?.info?.meetingName}</div>
              <div className={Style.desc}>
                {meeting?.isCalendarMode ? (
                  <div className={Style['desc-item']}>
                    <div className={Style.text}>
                      {getMeetingTime(meeting?.info?.scheduleStartTime)}
                    </div>
                    <div className={Style.split}>|</div>
                    <div className={Style.text}>
                      {formatMessage({ id: 'CONFERENCE_NUMBER' })}
                      <MeetingId meetingId={meetingId} />
                    </div>
                  </div>
                ) : null}
              </div>

              <div className={classNames(Style.formName)}>
                {meeting?.info?.needPassword && (
                  <div className={Style.password}>
                    <span className={Style.label}>{formatMessage({ id: 'password' })}</span>
                    <Input
                      className={Style.input}
                      maxLength={7}
                      autoFocus
                      value={passwordUI}
                      onChange={onPasswordChange}
                    />
                    <span className={classNames(Style.errTip, { [Style.show]: pwdError })}>
                      {formatMessage({ id: 'enterPassword' })}
                    </span>
                  </div>
                )}

                <div className={Style.name}>
                  <span className={Style.label}>{formatMessage({ id: 'userName' })}</span>
                  <Input
                    className={Style.input}
                    type="text"
                    maxLength={20}
                    value={inputValue}
                    onChange={onInputNameChange}
                  />
                  <span className={classNames(Style.errTip, { [Style.show]: hasError })}>
                    {formatMessage({ id: 'ENTER_YOUR_NAME' })}
                  </span>
                </div>
              </div>
              <div style={{ margin: '24px auto 0' }}>
                {meeting?.meetingStatus !== 2 && <FirstEnter onChange={setFirstMemberNotifyOn} />}
                <PrivatePolicy agreePolicy={agreePolicy} setAgreePolicy={setAgreePolicy} />
              </div>
              {(!mustCheck || !window.isWeb) && (
                <Button
                  onClick={() => {
                    elkLog('加入会议', {}, { meetingInfo: meeting?.info });
                    checkPrivate(joinMeeting, agreePolicy);
                  }}
                  loading={btnLoading}
                  type="primary"
                  className={classNames(Style['join-btn'], {
                    [Style.disabled]:
                      !inputValue || (meeting?.info?.needPassword && password.length !== 6),
                  })}
                >
                  {formatMessage({ id: 'JOIN' })}
                </Button>
              )}
              {mustCheck && window.isWeb && (
                <Button
                  onClick={nextStep}
                  type="primary"
                  className={classNames(Style['next-btn'], { [Style.disabled]: !inputValue })}
                >
                  {formatMessage({ id: 'NEXT_STEP' })}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  })
);
export default LoginInput;
